export type UsageRow = { date: string; count: number };

function toIso(d: Date): string {
  return d.toISOString().slice(0, 10);
}

function addDays(d: Date, n: number): Date {
  const out = new Date(d);
  out.setUTCDate(out.getUTCDate() + n);
  return out;
}

export function densifyUsage(rows: UsageRow[], days: number, today: Date = new Date()): UsageRow[] {
  const counts = new Map<string, number>();
  for (const r of rows) {
    counts.set(r.date, (counts.get(r.date) ?? 0) + r.count);
  }
  const out: UsageRow[] = [];
  for (let i = days - 1; i >= 0; i--) {
    const d = addDays(today, -i);
    const iso = toIso(d);
    out.push({ date: iso, count: counts.get(iso) ?? 0 });
  }
  return out;
}
